import request from '../utils/request'

/**
 * 创建定时任务
 */
export function createScheduledTask(data) {
  return request({
    url: '/admin/scheduled-task',
    method: 'post',
    data
  })
}

/**
 * 更新定时任务
 */
export function updateScheduledTask(data) {
  return request({
    url: '/admin/scheduled-task',
    method: 'put',
    data
  })
}

/**
 * 删除定时任务
 */
export function deleteScheduledTask(id) {
  return request({
    url: `/admin/scheduled-task/${id}`,
    method: 'delete'
  })
}

/**
 * 根据ID获取定时任务
 */
export function getScheduledTaskById(id) {
  return request({
    url: `/admin/scheduled-task/${id}`,
    method: 'get'
  })
}

/**
 * 分页查询定时任务列表
 */
export function getScheduledTaskList(params) {
  return request({
    url: '/admin/scheduled-task/list',
    method: 'get',
    params
  })
}

/**
 * 启用定时任务
 */
export function enableScheduledTask(id) {
  return request({
    url: `/admin/scheduled-task/${id}/enable`,
    method: 'post'
  })
}

/**
 * 禁用定时任务
 */
export function disableScheduledTask(id) {
  return request({
    url: `/admin/scheduled-task/${id}/disable`,
    method: 'post'
  })
}

/**
 * 执行一次定时任务
 */
export function executeScheduledTaskOnce(id) {
  return request({
    url: `/admin/scheduled-task/${id}/execute`,
    method: 'post'
  })
}

/**
 * 刷新所有定时任务
 */
export function refreshAllScheduledTasks() {
  return request({
    url: '/admin/scheduled-task/refresh',
    method: 'post'
  })
}

/**
 * 获取任务执行日志列表
 */
export function getScheduledTaskLogList(taskId, params) {
  return request({
    url: `/admin/scheduled-task/${taskId}/logs`,
    method: 'get',
    params
  })
}

